/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { SpinnerCircular, SpinnerRoundFilled } from "spinners-react";
import React from "react";

const Loading = () => {
  return (
    <div
      className="d-flex align-items-center justify-content-center"
      css={{
        height: "70vh",
        background: "white",
      }}
    >
      <SpinnerRoundFilled
        css={{
          marginTop: "10rem",
          marginBottom: "auto",
          //transform: "translate(-50%, -50%)",
        }}
        size={90}
        thickness={109}
        speed={109}
        color="#36ad47"
      />
    </div>
  );
};

export default Loading;
